module.exports = __webpack_public_path__ + "img/edit.db952d87.svg";